import { combineReducers } from 'redux';
import authReducer from './authReducer';
import userReducer from './userReducer'; // Assuming you have a userReducer
import geojsonReducer from './geojsonReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  data:geojsonReducer
});

export default rootReducer;
